import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskSVG = ({ size = '1em', ...otherSvgProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 18L17 6C17 5.44772 16.5523 5 16 5L8 5C7.44772 5 7 5.44771 7 6L7 18C7 18.5523 7.44772 19 8 19L16 19C16.5523 19 17 18.5523 17 18ZM18 6C18 4.89543 17.1046 4 16 4L8 4C6.89543 4 6 4.89543 6 6L6 18C6 19.1046 6.89543 20 8 20L16 20C17.1046 20 18 19.1046 18 18L18 6Z"
        fill="#BCBEC2"
      />
      <g clipPath="url(#clip0)">
        <path
          d="M10.7018 16.0454L9.21342 14.5566C9.14514 14.4883 9.09098 14.4073 9.05402 14.3182C9.01707 14.229 8.99805 14.1334 8.99805 14.0369C8.99805 13.9404 9.01707 13.8448 9.05402 13.7557C9.09098 13.6665 9.14514 13.5855 9.21342 13.5173C9.35131 13.3796 9.5382 13.3023 9.73306 13.3023C9.92792 13.3023 10.1148 13.3796 10.2527 13.5173L11.1848 14.4486C11.2036 14.4673 11.2291 14.4777 11.2556 14.4777C11.2821 14.4777 11.3075 14.4673 11.3263 14.4486L13.7434 12.0314C13.8813 11.8937 14.0682 11.8164 14.2631 11.8164C14.4579 11.8164 14.6448 11.8937 14.7827 12.0314C14.851 12.0996 14.9051 12.1807 14.9421 12.2698C14.9791 12.359 14.9981 12.4545 14.9981 12.5511C14.9981 12.6476 14.9791 12.7432 14.9421 12.8323C14.9051 12.9215 14.851 13.0025 14.7827 13.0707L11.8084 16.0454C11.6617 16.1921 11.4626 16.2746 11.2551 16.2746C11.0476 16.2746 10.8486 16.1921 10.7018 16.0454Z"
          fill="#55585E"
        />
      </g>
      <rect x="8" y="7" width="8" height="1" fill="#BCBEC2" />
      <rect x="8" y="9" width="6" height="1" fill="#BCBEC2" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      <defs>
        <clipPath id="clip0">
          <rect width="6" height="6" fill="white" transform="translate(9 11)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TaskSVG;
